import React, { Component } from 'react';
import { CheckboxEditor } from '../../components';
import s from './HostStyles.module.scss';

export default class CheckboxEditorEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { boxOne: false, boxTwo: true, boxThree: false };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <CheckboxEditor
                    value={this.state.boxOne}
                    label="Hello, friend"
                    onValueChanged={checked => {
                        this.setState({ boxOne: checked });
                    }}
                />
                <br />
                <CheckboxEditor
                    value={this.state.boxTwo}
                    label="Goodbye, pal"
                    onValueChanged={checked => {
                        this.setState({ boxTwo: checked });
                    }}
                />
                <br />
                <CheckboxEditor
                    disabled
                    value={this.state.boxThree}
                    label="I haz disabled"
                    onValueChanged={checked => {
                        this.setState({ boxThree: checked });
                    }}
                />
            </div>
        );
    }
}
